import { addUserRequestBuryRecordAll } from '../api/api'
import Cookies from 'js-cookie'
const language = navigator.language
const cl = language.split('-')[0]
/**
 * self server 埋点
 * @param option
 */
export const triggerService = function (option = {}) {
  const date = new Date()
  const platformType = Cookies.get('platformType') || ''
  const deviceId = Cookies.get('deviceId') || ''
  const userId = Cookies.get('userId') || ''
  const appId = Cookies.get('appId') || ''
  const countryId = Cookies.get('countryId') || ''
  const params = {
    eventId: '104-1-1-1',
    userId, // 用户编号（用户用账号或者ID登陆之后必须返回该字段信息）
    appId,
    platformType, // 平台：1 ios，2 android，3 other
    freeName2: '', // 备注
    cl: cl, // 系统语言
    capi: countryId, // 国家 ID
    countryId, // 国家 ID
    deviceId, // 用户设备唯一id
    createTime: date.format('yyyy-MM-dd hh:mm:ss')
  }

  try {
    addUserRequestBuryRecordAll(Object.assign({}, params, option))
  } catch (e) {
  }
}

export default {
  triggerService
}
